import PermissionsList from '../services/auth/PermissionsList'
const {
    AUTHORIZE_OPEN_CASH_DESK,
    AUTHORIZE_INGRESS_CASH_DESK,
    AUTHORIZE_EGRESS_CASH_DESK,
    EXECUTE_CLOSE_CASH_DESK,
    EXECUTE_CHANGE_VOUCHER_COUNTER,
    AUTHORIZE_GENERATE_CREDIT_NOTE,
    CREATE_AUTH_POS_DAILY_SALE_REPORT,
} = PermissionsList
export default {
    data() {
        return {
            mixAuthCodePermissions: {
                AUTHORIZE_OPEN_CASH_DESK,
                AUTHORIZE_INGRESS_CASH_DESK,
                AUTHORIZE_EGRESS_CASH_DESK,
                EXECUTE_CLOSE_CASH_DESK,
                EXECUTE_CHANGE_VOUCHER_COUNTER,
                AUTHORIZE_GENERATE_CREDIT_NOTE,
                CREATE_AUTH_POS_DAILY_SALE_REPORT,
            },
        }
    },
}
